import { ImageInterface } from '../image/Image';
import { Gender } from '../user/UserProfile';

export interface TeamRoleInterface {
  id?: number;
  publicId?: string;
  name: string;
  description?: string;
}

export interface TeamMemberInterface {
  id?: number;
  publicId?: string;
  created?: string;
  createdByEMail?: string;
  updated?: string;
  updatedByEMail?: string;
  email: string;
  phone?: string;
  firstname: string;
  name: string;
  role: string;
  description: string;
  primary: boolean;
  memberRole: TeamRole;
  birthdate?: string;
  gender?: Gender;
  image: ImageInterface;
}

// Keeping the enum for backward compatibility
export enum TeamRole {
  BOARD_MEMBER = 'BOARD_MEMBER',
  TREASURER = 'TREASURER',
  SECRETARY = 'SECRETARY',
  OTHER = 'OTHER',
}
